import { render, staticRenderFns } from "./bsHeader.vue?vue&type=template&id=2c6be339&scoped=true&"
import script from "./bsHeader.vue?vue&type=script&lang=js&"
export * from "./bsHeader.vue?vue&type=script&lang=js&"
import style0 from "./bsHeader.vue?vue&type=style&index=0&id=2c6be339&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6be339",
  null
  
)

export default component.exports